import { render, staticRenderFns } from "./ServiceEditor.vue?vue&type=template&id=2951e0b8"
import script from "./ServiceEditor.vue?vue&type=script&lang=js"
export * from "./ServiceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports